module.exports = __webpack_public_path__ + "static/media/ic_proyectos_truck_pin_seleccionado.62ed4593.svg";